export default {"src":"/_next/static/media/toss-icon.adbd286c.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};